// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAv0yN64JxbwoI9i7xcZiXkGr06WchP1hk",
  authDomain: "spkl-sto.firebaseapp.com",
  projectId: "spkl-sto",
  storageBucket: "spkl-sto.appspot.com",
  messagingSenderId: "508461830322",
  appId: "1:508461830322:web:da659d9ca36aa963ca79ab",
  measurementId: "G-3DNZ4Y1SXM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const analytics = getAnalytics(app);
export { auth, analytics, app };
